import "../scss/main.scss";

document.addEventListener("DOMContentLoaded", () => {
	const video = document.querySelector(".header-media__video");
	const toggle = document.querySelector(".header-media__toggle");

	if (!video || !toggle) {
		return;
	}

	const updateState = () => {
		const isPaused = video.paused;
		toggle.classList.toggle("is-paused", isPaused);
		toggle.setAttribute("aria-pressed", isPaused ? "true" : "false");
		toggle.setAttribute(
			"aria-label",
			isPaused ? "Lire la vidéo" : "Mettre la vidéo en pause"
		);
	};

	toggle.addEventListener("click", () => {
		if (video.paused) {
			video.play();
		} else {
			video.pause();
		}
	});

	// Assume autoplay first, then sync once playback state is known.
	if (video.autoplay) {
		toggle.classList.remove("is-paused");
		toggle.setAttribute("aria-pressed", "false");
		toggle.setAttribute("aria-label", "Mettre la vidéo en pause");
	}

	video.addEventListener("play", updateState);
	video.addEventListener("pause", updateState);
	video.addEventListener("loadeddata", updateState);

	setTimeout(updateState, 300);
});

document.addEventListener("DOMContentLoaded", () => {
	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		return;
	}

	const sections = document.querySelectorAll("section:not(footer section), footer");
	if (!sections.length) {
		return;
	}

	sections.forEach((section) => {
		section.classList.add("reveal-section");
		Array.from(section.children).forEach((child, index) => {
			if (child.nodeType !== 1) {
				return;
			}
			child.style.setProperty("--reveal-delay", `${index * 80}ms`);
		});
	});

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add("is-revealed");
					observer.unobserve(entry.target);
				}
			});
		},
		{ threshold: 0.15, rootMargin: "0px 0px -20% 0px" }
	);

	sections.forEach((section) => observer.observe(section));
});

function initGalleryMasonryGapSync(rootDocument, rootWindow) {
	const galleries = rootDocument.querySelectorAll(
		".wp-block-gallery.is-style-empile-colonnes"
	);
	if (!galleries.length) {
		return;
	}

	const syncGap = (gallery) => {
		const styles = rootWindow.getComputedStyle(gallery);
		const rowGap = styles.rowGap;
		const columnGap = styles.columnGap;

		if (rowGap && rowGap !== "normal" && rowGap !== "0px") {
			gallery.style.setProperty("--ml-gallery-row-gap", rowGap);
		} else {
			gallery.style.removeProperty("--ml-gallery-row-gap");
		}

		if (columnGap && columnGap !== "normal" && columnGap !== "0px") {
			gallery.style.setProperty("--ml-gallery-column-gap", columnGap);
		} else {
			gallery.style.removeProperty("--ml-gallery-column-gap");
		}
	};

	galleries.forEach((gallery) => {
		syncGap(gallery);

		const mo = new MutationObserver(() => syncGap(gallery));
		mo.observe(gallery, { attributes: true, attributeFilter: ["style", "class"] });
	});

	rootWindow.addEventListener(
		"resize",
		() => {
			galleries.forEach((gallery) => syncGap(gallery));
		},
		{ passive: true }
	);
}

document.addEventListener("DOMContentLoaded", () => {
	// Front (ou si pas d'iframe éditeur)
	initGalleryMasonryGapSync(document, window);

	// Éditeur Gutenberg (canvas dans une iframe)
	const iframe =
		document.querySelector('iframe[name="editor-canvas"]') ||
		document.querySelector(".block-editor-iframe__container iframe");

	if (!iframe) {
		return;
	}

	const tryInit = () => {
		const doc = iframe.contentDocument;
		const win = iframe.contentWindow;
		if (doc && win) {
			initGalleryMasonryGapSync(doc, win);
		}
	};

	if (iframe.contentDocument?.readyState === "complete") {
		tryInit();
	} else {
		iframe.addEventListener("load", tryInit, { once: true });
	}
});
